import CollectionProto from "../../data-structures/depricated/collection-proto"
import DatetimeUtils from "../../gd/utils/datetime-utils"

const debug = false
// const debug = "DocumentHistory"

interface DocumentHistoryRecordConfig {
    id              : string
    moment          : string
    noteHistoryType : number
    userId          : string
}


class DocumentHistoryRecord {

    public id               : string
    public moment           : Moment
    public noteHistoryType  : number
    public userId           : string

    constructor(data:DocumentHistoryRecordConfig) {
        this.id                 = data.id
        this.moment             = DatetimeUtils.datetimeToMoment(data.moment)
        this.noteHistoryType    = data.noteHistoryType
        this.userId             = data.userId
    }
}


export default class DocumentHistory extends CollectionProto<DocumentHistoryRecord> {
    constructor(models: object[]) {
        debug && console.log(debug, "constructor", models)

        super(models, DocumentHistoryRecord)

        const orderedIds = _(this.models)
            .orderBy(h=>h.moment.format('x'), 'desc')
            .map(h=>h.id)
            .value()

        this.reorderByIds(orderedIds)

        debug && console.log(debug, "constructor this.models", this.models)
    }

    get first(): DocumentHistoryRecord {
        return this.models[0]
    }

    get last(): DocumentHistoryRecord {
        return this.models[this.length-1]
    }
}


